import { buttons } from './buttons'
import { colors } from './colors'
import { shadows } from './shadows'
import { space } from './space'
import { radii } from './radii'
import {
  letterSpacings,
  lineHeights,
  fonts,
  fontSizes,
  fontWeights,
} from './fonts'
import { styles } from './styles'
import { text } from './text'
import { links } from './links'
import { sizes } from './sizes'
import { forms } from './forms'
import { zIndices } from './zIndices'
import { images } from './images'
import { badges } from './badges'
import { borderWidths } from './borderWidths'
import { utils } from './utils'
import { breakpoints } from './breakpoints'

export default {
  useColorSchemeMediaQuery: true,
  buttons,
  colors,
  shadows,
  space,
  radii,
  letterSpacings,
  lineHeights,
  fonts,
  fontSizes,
  fontWeights,
  borderWidths,
  breakpoints,
  styles,
  text,
  links,
  sizes,
  forms,
  zIndices,
  images,
  badges,
  utils,
}
